interface Feature {
  component: React.ReactNode
  title: React.ReactNode
  description: React.ReactNode
}

interface ThreeFeaturesSectionProps {
  features: [Feature, Feature, Feature]
}

export function ThreeFeaturesSection({ features }: ThreeFeaturesSectionProps) {
  const [primary, secondary, tertiary] = features

  return (
    <div className="flex flex-col gap-24">
      {/* Feature 1: Headline left, description right, full-width component below */}
      <div className="w-full max-w-[1470px] relative">
        <div className="flex flex-col gap-8">
          {/* Text row: Headline left, description right */}
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 lg:gap-12">
            <h3 className="text-2xl lg:text-3xl font-medium tracking-tighter lg:flex-1 max-w-[400px] text-balance">
              {primary.title}
            </h3>
            <p className="text-base text-fg-secondary lg:flex-1 max-w-[450px] text-balance">
              {primary.description}
            </p>
          </div>

          {/* Full-width component below */}
          <div className="w-full">{primary.component}</div>
        </div>
      </div>

      {/* Features 2 & 3: Text above, visualizations aligned horizontally */}
      <div className="w-full max-w-[1470px] relative">
        {/* Mobile: Stack features vertically */}
        <div className="flex flex-col gap-12 lg:hidden">
          {/* Feature 2 */}
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-3">
              <h3 className="text-2xl font-medium tracking-tighter">{secondary.title}</h3>
              <p className="text-base text-fg-secondary text-pretty">{secondary.description}</p>
            </div>
            {secondary.component}
          </div>

          {/* Feature 3 */}
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-3">
              <h3 className="text-2xl font-medium tracking-tighter">{tertiary.title}</h3>
              <p className="text-base text-fg-secondary text-pretty">{tertiary.description}</p>
            </div>
            {tertiary.component}
          </div>
        </div>

        {/* Desktop: Separate rows for text and components to ensure alignment */}
        <div className="hidden lg:flex lg:flex-col lg:gap-6">
          {/* Text row */}
          <div className="grid grid-cols-2 gap-16">
            {/* Feature 2 text */}
            <div className="flex flex-col gap-3">
              <h3 className="text-2xl font-medium tracking-tighter">{secondary.title}</h3>
              <p className="text-base text-fg-secondary text-pretty">{secondary.description}</p>
            </div>

            {/* Feature 3 text */}
            <div className="flex flex-col gap-3">
              <h3 className="text-2xl font-medium tracking-tighter">{tertiary.title}</h3>
              <p className="text-base text-fg-secondary text-pretty">{tertiary.description}</p>
            </div>
          </div>

          {/* Components row - perfectly aligned */}
          <div className="grid grid-cols-2 gap-16">
            {secondary.component}
            {tertiary.component}
          </div>
        </div>
      </div>
    </div>
  )
}
